import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Calendar, MapPin, Clock } from 'lucide-react';
const events = [{
  date: {
    month: 'MAR',
    day: '15'
  },
  title: 'Parent-Teacher Meeting',
  description: 'Quarterly meeting to discuss student progress and academic performance',
  time: '10:00 AM - 2:00 PM',
  location: 'School Auditorium'
}, {
  date: {
    month: 'MAR',
    day: '22'
  },
  title: 'Annual Science Fair',
  description: 'Students showcase innovative projects and scientific experiments',
  time: '9:00 AM - 4:00 PM',
  location: 'Main Campus'
}, {
  date: {
    month: 'APR',
    day: '05'
  },
  title: 'Inter-School Sports Day',
  description: 'Athletic competitions featuring various sports and games',
  time: '8:00 AM - 5:00 PM',
  location: 'Sports Complex'
}, {
  date: {
    month: 'APR',
    day: '18'
  },
  title: 'Cultural Program',
  description: 'Annual cultural celebration showcasing student talents',
  time: '6:00 PM - 9:00 PM',
  location: 'School Auditorium'
}];
export function UpcomingEvents() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="py-20 bg-light-gray" data-id="element-278">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-281">
            Upcoming Events
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-282"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-283">
            Stay updated with our latest events and activities
          </p>
        </div>

        <div ref={ref} className="grid md:grid-cols-2 gap-6" data-id="element-284">
          {events.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all overflow-hidden" data-id="element-285">
              <div className="flex" data-id="element-286">
                <div className="bg-primary text-white p-6 flex flex-col items-center justify-center min-w-[100px]" data-id="element-287">
                  <div className="text-sm font-semibold" data-id="element-288">
                    {event.date.month}
                  </div>
                  <div className="text-4xl font-heading font-bold" data-id="element-289">
                    {event.date.day}
                  </div>
                </div>
                <div className="p-6 flex-1" data-id="element-290">
                  <h3 className="text-xl font-heading font-semibold text-text-dark mb-2" data-id="element-291">
                    {event.title}
                  </h3>
                  <p className="text-text-muted mb-4" data-id="element-292">{event.description}</p>
                  <div className="space-y-2 text-sm text-text-muted" data-id="element-293">
                    <div className="flex items-center gap-2" data-id="element-294">
                      <Clock size={16} className="text-gold" data-id="element-295" />
                      <span data-id="element-296">{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-297">
                      <MapPin size={16} className="text-gold" data-id="element-298" />
                      <span data-id="element-299">{event.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}